import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueApollo from 'vue-apollo'

import i18n from '@/libs/i18n'
import apolloClient from '@/libs/apollo'
import Loading from './plugins/loading'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'
import './filters/filters'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/acl'
import './registerServiceWorker'
import '@/libs/pwa-install'

Vue.use(VueApollo)
Vue.use(VueCompositionAPI)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
// Composition API

Vue.use(Loading, store)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: h => h(App),
}).$mount('#app')
